import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useMapViewFeatureEnabled() {
  const feature = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.MapView),
  )

  return feature?.enabled ?? false
}
